const SizeConverter = (function() {
  const menUS = {
    39: 6, 39.5: 6.5, 40: 7, 40.5: 7.5, 41: 8, 41.5: 8.5, 
    42: 9, 42.5: 9.5, 43: 10, 43.5: 10.5, 44: 11, 44.5: 11.5, 
    45: 12, 45.5: 12.5, 46: 13, 47: 14, 48: 15, 49: 16
  };
  
  const womenUS = {
    34: 4, 34.5: 4.5, 35: 5, 35.5: 5.5, 36: 6, 37: 6.5, 
    37.5: 7, 38: 7.5, 38.5: 8, 39: 8.5, 39.5: 9, 40: 9.5, 
    40.5: 10, 41: 10.5, 42: 11, 42.5: 11.5, 43: 12
  };
  
  const menUK = {
    39: 5, 39.5: 5.5, 40: 6, 40.5: 6.5, 41: 7, 41.5: 7.5, 
    42: 8, 42.5: 8.5, 43: 9, 43.5: 9.5, 44: 10, 44.5: 10.5, 
    45: 11, 45.5: 11.5, 46: 12, 47: 13, 48: 14, 49: 15
  };
  
  const womenUK = {
    34: 1.5, 34.5: 2, 35: 2.5, 35.5: 3, 36: 3.5, 37: 4, 
    37.5: 4.5, 38: 5, 38.5: 5.5, 39: 6, 39.5: 6.5, 40: 7, 
    40.5: 7.5, 41: 8, 42: 8.5, 42.5: 9, 43: 9.5
  };

  function detectGender(container) {
    // The size range is conclusive when it falls outside the other chart
    const sizes = Array.from(container.querySelectorAll('[data-attr-value]'))
      .map(function(el) { return parseFloat(el.getAttribute('data-attr-value')); })
      .filter(function(n) { return n >= 30 && n <= 50; });
    if (sizes.some(function(n) { return n > 43; })) return 'men';
    if (sizes.some(function(n) { return n < 39; })) return 'women';

    if (container.dataset.gender === 'men' || container.dataset.gender === 'women') {
      return container.dataset.gender;
    }

    const productInfo = container.closest('.product') || container.closest('[id^="MainProduct-"]');
    if (productInfo) {
      const productText = (productInfo.textContent || productInfo.innerText || '').toLowerCase();
      if (productText.includes('men') && !productText.includes('women')) return 'men';
      if (productText.includes('women')) return 'women';
    }
    
    const url = window.location.href.toLowerCase();
    if (url.includes('men') && !url.includes('women')) return 'men';
    if (url.includes('women')) return 'women';
    
    return 'women';
  }

  function convertToEU(container) {
    const ukBtn = container.querySelector(".uk");
    const usBtn = container.querySelector(".us");
    const euBtn = container.querySelector(".eu");
    
    if (ukBtn) ukBtn.classList.remove("active");
    if (usBtn) usBtn.classList.remove("active");
    if (euBtn) euBtn.classList.add("active");
    
    for (let i = 35; i < 48; i += 0.5) {
      const element = container.querySelector('[data-attr-value="' + i + '"]');
      if (element) {
        element.innerHTML = i;
      }
    }
  }

  function convertToUS(container) {
    const euBtn = container.querySelector(".eu");
    const usBtn = container.querySelector(".us");
    const ukBtn = container.querySelector(".uk");
    
    if (euBtn) euBtn.classList.remove("active");
    if (usBtn) usBtn.classList.add("active");
    if (ukBtn) ukBtn.classList.remove("active");
    
    const gender = detectGender(container);
    const conversionTable = gender === 'men' ? menUS : womenUS;
    
    for (let i = 35; i < 48; i += 0.5) {
      const element = container.querySelector('[data-attr-value="' + i + '"]');
      if (element && conversionTable[i]) {
        element.innerHTML = conversionTable[i];
      }
    }
  }

  function convertToUK(container) {
    const euBtn = container.querySelector(".eu");
    const ukBtn = container.querySelector(".uk");
    const usBtn = container.querySelector(".us");
    
    if (euBtn) euBtn.classList.remove("active");
    if (ukBtn) ukBtn.classList.add("active");
    if (usBtn) usBtn.classList.remove("active");
    
    const gender = detectGender(container);
    const conversionTable = gender === 'men' ? menUK : womenUK;
    
    for (let i = 35; i < 48; i += 0.5) {
      const element = container.querySelector('[data-attr-value="' + i + '"]');
      if (element && conversionTable[i]) {
        element.innerHTML = conversionTable[i];
      }
    }
  }

  function init(container) {
    if (!container) return;
    
    const euBtn = container.querySelector(".eu");
    const usBtn = container.querySelector(".us");
    const ukBtn = container.querySelector(".uk");
    
    if (!euBtn || !usBtn || !ukBtn) return;
    
    if (container.dataset.sizeConverterInitialized === 'true') {
      return;
    }
    
    container.dataset.sizeConverterInitialized = 'true';
    
    euBtn.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      convertToEU(container);
      return false;
    };
    
    usBtn.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      convertToUS(container);
      return false;
    };
    
    ukBtn.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      convertToUK(container);
      return false;
    };
  }

  function initAll() {
    document.querySelectorAll('[id^="variant-radios-"]').forEach(function(container) {
      delete container.dataset.sizeConverterInitialized;
      init(container);
    });
  }

  return {
    init: init,
    initAll: initAll
  };
})();

window.initializeSizeConverter = function(container) {
  if (container) {
    delete container.dataset.sizeConverterInitialized;
    SizeConverter.init(container);
  } else {
    SizeConverter.initAll();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', SizeConverter.initAll);
} else {
  SizeConverter.initAll();
}

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) {
        if (node.querySelector && node.querySelector('[id^="variant-radios-"]')) {
          setTimeout(function() {
            node.querySelectorAll('[id^="variant-radios-"]').forEach(function(vr) {
              window.initializeSizeConverter(vr);
            });
          }, 300);
        }
        if (node.id && node.id.startsWith('variant-radios-')) {
          setTimeout(function() {
            window.initializeSizeConverter(node);
          }, 300);
        }
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
